import type { OpenStatus } from '../../lib/twin';

interface Props {
  status: OpenStatus;
  className?: string;
}

/**
 * Live "Open now · until 6:00 PM" / "Closed · Opens at 7:00 AM" pill.
 *
 * Accessibility: status is conveyed in text (not color alone) and a dot uses an
 * aria-hidden glyph; the role=status announces changes politely.
 */
export function OpenStatusBadge({ status, className = '' }: Props) {
  const tone = status.isOpen
    ? 'bg-open/10 text-open ring-open/30'
    : 'bg-closed/10 text-closed ring-closed/30';

  return (
    <span
      role="status"
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-semibold ring-1 ring-inset ${tone} ${className}`}
    >
      <span aria-hidden="true" className="text-[0.6rem] leading-none">
        {status.isOpen ? '●' : '○'}
      </span>
      {status.label}
    </span>
  );
}
